module.exports = __webpack_public_path__ + "static/media/avatar_inactive.a9afe469.svg";